import {
  getAaveAssets,
  getAaveTypePoolDataProviderAddress,
} from '../../../assets'

export const buildAaveV2StyleLenderReserveCall = (
  chainId: string,
  lender: string,
) => {
  const providerAddress = getAaveTypePoolDataProviderAddress(chainId, lender)
  const underlyingTokensArray = getAaveAssets(chainId, lender)
  switch (lender) {
    default:
      return [
        ...underlyingTokensArray.flatMap((tk) => [
          {
            address: providerAddress,
            name: 'getReserveData',
            params: [tk],
          },
          {
            address: providerAddress,
            name: 'getReserveConfigurationData',
            params: [tk],
          },
        ]),
      ]
  }
}
